module.exports = __webpack_public_path__ + "static/media/fire-water-icon.988a7709.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/fire-water-icon.png
// module id = 1256
// module chunks = 0